import React, { useEffect } from 'react'
import BEMHelper from '@ynap/bem-helper'

import Skeleton from '@ynap/skeleton'

import { CoremediaRenderer } from '@ycos/coremedia-renderer'
import ServiceMessageWrapper from '@ycos/component-service-message-wrapper'
import ServiceMessageBlock from '@ycos/component-service-message-block'

import CustomerCare from '../CustomerCare/CustomerCare'

export const ServiceMessageKey = 'serviceMessageWrapper'
export const EIPServiceMessageKey = 'serviceMessageWrapperEIP'

export type ServiceMessageContentType = {
    key: string
    layoutVariant: string
    locale: string
    type: string
    items: Array<{
        type: string
        layoutVariant: string
        teaserText: string
        teaserTextPlain: string
        teaserTitle: string
    }>
}

type ServiceMessageProps = {
    enableEditorialContent: boolean | undefined
    isEip: boolean | undefined
    content: ServiceMessageContentType
    fetchContent: (
        componentKey: string,
        countryCode?: string | null,
        options?: { mv?: 'gitMarkdown'; f?: 'ycos' } | null,
        v2?: boolean
    ) => any
    isFetchingContent: boolean | undefined
    fetchContentError: boolean
    messages?: Record<string, (() => string) | Record<string, () => string>>
    links?: Record<string, string>
    locale?: {
        country: string
        currency: string
        id: string
        language: string
    }
}

const bem = new BEMHelper('ServiceMessage')

const ServiceMessage: React.FC<ServiceMessageProps> = ({
    enableEditorialContent,
    isEip,
    content,
    fetchContent,
    isFetchingContent,
    fetchContentError,
    messages,
    links,
    locale,
}) => {
    useEffect(() => {
        if (!enableEditorialContent) {
            return
        }

        if (!content && !isFetchingContent && !fetchContentError) {
            fetchContent(isEip ? EIPServiceMessageKey : ServiceMessageKey, null, { mv: 'gitMarkdown' })
        }
    }, [isEip, content, enableEditorialContent, isFetchingContent, fetchContentError])

    if (enableEditorialContent && (isFetchingContent === undefined || isFetchingContent)) {
        return (
            <div className={bem('skeletonWrapper')}>
                <Skeleton className={bem('skeleton')} />
            </div>
        )
    }

    if (enableEditorialContent && content) {
        return (
            <div className={bem('editorialContainer')}>
                {CoremediaRenderer(content, [ServiceMessageWrapper, ServiceMessageBlock])}
            </div>
        )
    }

    if (!messages) {
        return null
    }

    return <CustomerCare messages={messages} links={links} locale={locale} />
}

export default ServiceMessage
